import { Component, OnInit } from '@angular/core';
import { DataService } from './shared/dataService';
import { JobOffer } from './shared/joboffer';
import { Router } from '@angular/router';

@Component({
  selector: 'app-start',
  templateUrl: "./app.component.html",
    styleUrls: []
})
export class AppComponent {
    constructor(private data : DataService, private router : Router) {
    }
    
    public menuLogout(event: Event): void {
        event.preventDefault();
        this.data.logout();
    }
}
